// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import * as z from 'zod';
import {
  CRMConfigurationPage,
  hubspotPropertyConfigurationResponseSchema,
} from '@/account/api/types';
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';

/** Type representing the validated response from updating an organization */
type UpdateHubspotPropertyMappingResponse = z.infer<
  typeof hubspotPropertyConfigurationResponseSchema
>;

interface HubspotPropertyMappingUpdateParameters {
  propertyId: string;
  objectType: string;
  value: string | null;
}

export async function updateHubspotPropertyMapping(
  page: CRMConfigurationPage,
  parameters: HubspotPropertyMappingUpdateParameters[]
): Promise<UpdateHubspotPropertyMappingResponse> {
  const url = `/v1/crm/hubspot/properties/${page.toLowerCase()}`;
  const response = await api.post(url, parameters);

  return parseResponse(
    hubspotPropertyConfigurationResponseSchema,
    response.data,
    {
      schemaName: 'UpdateHubspotPropertyMapping',
      endpoint: url,
    }
  );
}

export async function syncHubspotProperties(
  propertyId: string
): Promise<UpdateHubspotPropertyMappingResponse> {
  const url = `/v1/crm/hubspot/properties/${propertyId}/sync`;
  const response = await api.post(url);

  return parseResponse(
    hubspotPropertyConfigurationResponseSchema,
    response.data,
    {
      schemaName: 'SyncHubspotProperties',
      endpoint: url,
    }
  );
}

export const hubspotDealPropertyQueryKey = ['hubspot', 'properties', 'deals'];
export const hubspotCompanyPropertyQueryKey = [
  'hubspot',
  'properties',
  'companies',
];
export const hubspotProductPropertyQueryKey = [
  'hubspot',
  'properties',
  'products',
];

export const salesforceDealPropertyQueryKey = [
  'salesforce',
  'properties',
  'deals',
];

export const salesforceCompanyPropertyQueryKey = [
  'salesforce',
  'properties',
  'companies',
];

export const salesforceProductPropertyQueryKey = [
  'salesforce',
  'properties',
  'products',
];
